export enum AskReplikaCategories {
  Prompts = 'prompts',
}
